import React from 'react';

interface Props {
  label?: string;
  large?: boolean;
}

export function LoadingState({ label = 'Loading...', large = false }: Props) {
  return (
    <div className="state" role="status" aria-live="polite">
      <span className={`spinner${large ? ' lg' : ''}`} aria-hidden="true" />
      <div className="mt-3">{label}</div>
    </div>
  );
}
